import { createApp } from 'vue';

import App from './views/app.vue';
import { router } from './router';

const app = createApp(App);

app.config.errorHandler = function (err, instance, info) {
  console.error(err, info);
}
app.config.warnHandler = function (msg, instance, trace) {
  console.warn(msg, trace);
}

app.use(router);

app.mount('#app');
